import _axios from '@/utils/request'

// 视频集列表
export function postVideoList (params) {
    return _axios('post', `/ms-shulan-hospital/v1/bannerCollect/bannerList`, params)
}

// 上传视频集
export function postVideoUpload (params) {
    return _axios('post', `/ms-shulan-hospital/v1/bannerCollect`, params)
}

// 更新视频集
export function putVideoUpload (params) {
    return _axios('put', `/ms-shulan-hospital/v1/bannerCollect`, params)
}

// 删除视频集
export function deleteVideo (videoId) {
    return _axios('delete', `/ms-shulan-hospital/v1/bannerCollect/${videoId}`)
}

export function getVideoList (videoId) {
    return _axios('get', `/ms-shulan-hospital/v1/bannerCollect/${videoId}`)
}
